import { SvgIcon } from "@mui/material";
import React from "react";

export default function ChatIcon({ fill = "#FAFAFA", ...props }: any) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        {...props}
      >
        <path
          d="M6.58341 16.6666C8.1739 17.4825 10.0035 17.7035 11.7425 17.2898C13.4815 16.876 15.0155 15.8548 16.0682 14.4101C17.1209 12.9654 17.6229 11.1922 17.4839 9.41009C17.3449 7.62797 16.5739 5.9541 15.3099 4.69012C14.0459 3.42614 12.3721 2.65517 10.5899 2.51614C8.80782 2.37711 7.03464 2.87916 5.58993 3.93183C4.14522 4.9845 3.12399 6.51855 2.71027 8.25755C2.29654 9.99655 2.51753 11.8261 3.33341 13.4166L1.66675 18.3333L6.58341 16.6666Z"
          stroke={fill}
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
